import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis, scrollToId } from "@/hooks/useLenis";

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => scrollToId(hash.slice(1)), 400);
      return () => clearTimeout(timer);
    }
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
};
